// when clicked the map zooms out out level

import MapView = require("../views/MapView");
import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");

class Command extends Base<{}> {

    static about = `
zoom the map in or out

Usage Example:

\`\`\`xml
<COMMAND disabled="False" id="zoom-out" mid="app/commands/zoom" text="−" type="action">
  <OPTIONS>
    <Values id="direction" value="out" />
    <Values id="css-name" value="zoom-out" />
    <Values about="Tooltip Description" id="title" value="Zoom Out" />
  </OPTIONS>
</COMMAND>
\`\`\`

`;

    static options = Utils.defaults({
        "direction": {
            "required": true,
            "about": "in or out",
            "domain": "in|out",
        },
    }, Base.options);

    static output = {
        "direction": {
            "about": "forwards the direction to listeners",
            "domain": "in|out",
        },
    }

    execute(args = this.args) {

        var options = this.asOptions(Command.options);
        var direction = options.direction;
        if (!direction) {
            console.warn("no direction found");
            return;
        }

        this.mediator.mapView(mapView => {
            switch (direction) {
                case "in":
                    mapView.zoomIn();
                    break;
                case "out":
                    mapView.zoomOut();
                    break;
                default:
                    console.warn("unknown direction: ", direction);
            }

            // unnecessary - why place the direction on the bus a second time?
            this.trigger({ direction: direction });
        });
    }

}

export = Command; 